module.exports = __webpack_public_path__ + "static/media/book_others_spine.a7f1f7a3.png";